export const POS_CART_ADD = "POS_CART_ADD";
export const POS_CART_INC = "POS_CART_INC";
export const POS_CART_DEC = "POS_CART_DEC";
export const POS_CART_SET_QTY = "POS_CART_SET_QTY";
export const POS_CART_SET_PRICE = "POS_CART_SET_PRICE";
export const POS_CART_REMOVE = "POS_CART_REMOVE";
export const POS_CART_CLEAR = "POS_CART_CLEAR";
export const POS_CART_REPLACE = "POS_CART_REPLACE";
export const POS_CART_SET_DINEIN = "POS_CART_SET_DINEIN";
export const POS_CART_CLEAR_DINEIN = "POS_CART_CLEAR_DINEIN";
// Refund mode: the cart holds a paid bill's lines and gives money back.
export const POS_CART_START_REFUND = "POS_CART_START_REFUND";
export const POS_CART_END_REFUND = "POS_CART_END_REFUND";
